import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist/es/constants';

const initialState = { user: null, token: null };

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, { payload }) => {
      state.user = {
        login: payload.login,
        firstName: payload.firstName,
        lastName: payload.lastName,
        roles: payload.roles
      };
      state.token = payload.accessToken;
    },
    setUser: (state, { payload }) => {
      state.user = {
        login: payload.login,
        firstName: payload.firstName,
        lastName: payload.lastName,
        roles: payload.roles
      };
    },
    setToken: (state, { payload }) => {
      state.token = payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export const { setCredentials, setUser, setToken } = authSlice.actions;

export default authSlice;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.token;
